import { escapeHtml } from '../core/html.js?v=6.87.12';

const ICONS = Object.freeze({
  view: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"></path><circle cx="12" cy="12" r="2.7"></circle></svg>',
  eyeOff: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"></path><circle cx="12" cy="12" r="2.7"></circle><path d="M4 4l16 16"></path></svg>',
  edit: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20h4l11-11-4-4L4 16v4Z"></path><path d="m13.5 6.5 4 4"></path></svg>',
  add: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"></path></svg>',
  archive: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16v13H4z"></path><path d="M3 4h18v3H3zM9 11h6"></path></svg>',
  close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"></path></svg>',
  save: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 3h12l2 2v16H5z"></path><path d="M8 3v6h8V3M8 21v-8h8v8"></path></svg>',
  search: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="m16 16 5 5"></path></svg>',
  health: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12h4l2-5 4 10 2-5h6"></path></svg>',
  calendar: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h16v15H4zM8 2v6m8-6v6M4 10h16"></path></svg>',
  user: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="4"></circle><path d="M4 21a8 8 0 0 1 16 0"></path></svg>',
  bell: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9a6 6 0 0 1 12 0c0 7 3 7 3 7H3s3 0 3-7Zm4 11h4"></path></svg>',
  check: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12 4 4L19 6"></path></svg>',
  chevronLeft: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"></path></svg>',
  chevronRight: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6"></path></svg>',
  phone: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 3h4l2 5-3 2a16 16 0 0 0 6 6l2-3 5 2v4c0 1-1 2-2 2C10 21 3 14 3 5c0-1 1-2 2-2Z"></path></svg>',
  mail: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 5h18v14H3zM3 7l9 6 9-6"></path></svg>',
  users: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="8" r="3"></circle><circle cx="17" cy="9" r="2.5"></circle><path d="M3 20a6 6 0 0 1 12 0M14 15a5 5 0 0 1 7 5"></path></svg>',
  cargo: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 8h18v12H3zM7 8V4h10v4M3 13h18M8 13v7m8-7v7"></path></svg>',
  route: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="6" cy="18" r="2"></circle><circle cx="18" cy="6" r="2"></circle><path d="M8 18h3a4 4 0 0 0 4-4v-4a2 2 0 0 1 2-2"></path></svg>',
  information: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M12 11v6M12 7h.01"></path></svg>',
  list: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6h11M9 12h11M9 18h11"></path><circle cx="4.5" cy="6" r="1"></circle><circle cx="4.5" cy="12" r="1"></circle><circle cx="4.5" cy="18" r="1"></circle></svg>',
  transfer: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h13M13 3l4 4-4 4M20 17H7M11 13l-4 4 4 4"></path></svg>',
  clock: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M12 7v5l3.5 2"></path></svg>',
  copy: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 9h11v11H9z"></path><path d="M5 15V4h11v3"></path></svg>',
});

export function uiIcon(name) {
  return `<span class="rc5-action-icon">${ICONS[name] || ''}</span>`;
}

export function formatDate(value) {
  const text = String(value || '').trim();
  if (!text) return '—';
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(text);
  return match ? `${match[3]}.${match[2]}.${match[1]}` : text;
}

export function formatDateTime(value) {
  const text = String(value || '').trim();
  if (!text) return '—';
  const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(text);
  return match ? `${match[3]}.${match[2]}.${match[1]} ${match[4]}:${match[5]}` : formatDate(text);
}

/**
 * Server-generated timestamps (NOW()/CURRENT_TIMESTAMP columns) are stored in UTC.
 * Use this instead of formatDateTime() for those - never for business-entered dates
 * like ETA/ETB/ETD, which are plain wall-clock values with no timezone conversion.
 */
export function formatServerDateTime(value) {
  const text = String(value || '').trim();
  if (!text) return '—';
  const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/.exec(text);
  if (!match) return formatDate(text);
  const [, year, month, day, hour, minute, second] = match;
  const utcMs = Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second || 0));
  try {
    return new Intl.DateTimeFormat('ru-RU', {
      timeZone: 'Asia/Vladivostok', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
    }).format(new Date(utcMs)).replace(',', '');
  } catch (_) {
    return formatDateTime(value);
  }
}

export function dash(value) {
  const text = String(value ?? '').trim();
  return text === '' ? '—' : text;
}

/** Icon-only action for tables and compact toolbars. */
export function actionButton({ action, id = 0, label, icon = 'view', tone = 'neutral', attrs = '' }) {
  const idAttr = Number(id) > 0 ? ` data-id="${Number(id)}"` : '';
  return `<button type="button" class="rc5-row-action rc5-row-action--${escapeHtml(tone)}" data-action="${escapeHtml(action)}"${idAttr} title="${escapeHtml(label)}" aria-label="${escapeHtml(label)}" ${attrs}>${uiIcon(icon)}</button>`;
}

/** Text action for modal footers and primary form commands. */
export function textActionButton({ action, id = 0, label, icon = '', tone = 'neutral', type = 'button', attrs = '' }) {
  const idAttr = Number(id) > 0 ? ` data-id="${Number(id)}"` : '';
  return `<button type="${escapeHtml(type)}" class="rc5-text-action rc5-text-action--${escapeHtml(tone)}"${action ? ` data-action="${escapeHtml(action)}"` : ''}${idAttr} ${attrs}>${icon ? uiIcon(icon) : ''}<span>${escapeHtml(label)}</span></button>`;
}

/** Wrap a `type="password"` input with this to get a reveal/hide toggle button (see togglePasswordVisibility). */
export function passwordField(inputHtml) {
  return `<div class="rc5-password-field">${inputHtml}<button type="button" class="rc5-password-toggle" data-password-toggle aria-label="Показать пароль" aria-pressed="false">${uiIcon('view')}</button></div>`;
}

export function togglePasswordVisibility(button) {
  const input = button.closest('.rc5-password-field')?.querySelector('input');
  if (!input) return;
  const reveal = input.type === 'password';
  input.type = reveal ? 'text' : 'password';
  button.setAttribute('aria-pressed', reveal ? 'true' : 'false');
  button.setAttribute('aria-label', reveal ? 'Скрыть пароль' : 'Показать пароль');
  button.innerHTML = uiIcon(reveal ? 'eyeOff' : 'view');
}

export function userAvatar({ login = '', image = '', className = 'rc5-user__avatar' } = {}) {
  const imageSrc = String(image || '').trim();
  const fallback = String(login || '?').trim().slice(0, 1).toUpperCase() || '?';
  return `<span class="${escapeHtml(className)}" aria-hidden="true">${imageSrc ? `<img src="${escapeHtml(imageSrc)}" alt="">` : escapeHtml(fallback)}</span>`;
}

export function renderModal({ title, subtitle = '', body = '', footer = '', closeAction, size = 'lg', mode = 'view', labelledBy = '' }) {
  const titleId = labelledBy || `rc5-modal-title-${String(closeAction || 'dialog').replace(/[^a-z0-9_-]+/gi, '-')}`;
  return `<div class="rc5-modal-overlay" data-modal-overlay data-modal-close-action="${escapeHtml(closeAction)}" role="presentation">
    <section class="rc5-modal rc5-modal--${escapeHtml(size)} rc5-modal--${escapeHtml(mode)}" role="dialog" aria-modal="true" aria-labelledby="${escapeHtml(titleId)}" tabindex="-1">
      <header class="rc5-modal__header">
        <div><h2 id="${escapeHtml(titleId)}">${escapeHtml(title)}</h2>${subtitle ? `<p>${escapeHtml(subtitle)}</p>` : ''}</div>
        <button type="button" class="rc5-modal__close" data-action="${escapeHtml(closeAction)}" aria-label="Закрыть">${uiIcon('close')}</button>
      </header>
      <div class="rc5-modal__body">${body}</div>
      ${footer ? `<footer class="rc5-modal__footer">${footer}</footer>` : ''}
    </section>
  </div>`;
}

export function formSection({ title, description = '', body, icon = '' }) {
  return `<fieldset class="rc5-form-section"><legend>${icon ? uiIcon(icon) : ''}<span>${escapeHtml(title)}</span></legend>${description ? `<p class="rc5-form-section__description">${escapeHtml(description)}</p>` : ''}<div class="rc5-form-section__content">${body}</div></fieldset>`;
}

export function definitionSection({ title, body, icon = '' }) {
  return `<section class="rc5-detail-section"><h3>${icon ? uiIcon(icon) : ''}<span>${escapeHtml(title)}</span></h3>${body}</section>`;
}

export function tabs({ active, items, action = 'modal-tab', idPrefix = 'modal', ariaLabel = 'Разделы формы' }) {
  return `<div class="rc5-form-tabs" role="tablist" aria-label="${escapeHtml(ariaLabel)}">${items.map(item => {
    const tabId = `${idPrefix}-tab-${item.id}`;
    const panelId = `${idPrefix}-panel-${item.id}`;
    return `<button type="button" id="${escapeHtml(tabId)}" role="tab" aria-controls="${escapeHtml(panelId)}" aria-selected="${item.id === active ? 'true' : 'false'}" tabindex="${item.id === active ? '0' : '-1'}" data-action="${escapeHtml(action)}" data-tab="${escapeHtml(item.id)}"${item.disabled ? ' disabled' : ''}>${item.icon ? uiIcon(item.icon) : ''}<span>${escapeHtml(item.label)}</span></button>`;
  }).join('')}</div>`;
}

export function definitionGrid(entries) {
  return `<dl class="rc5-definition-grid">${entries.map(([label, value]) => `<div><dt>${escapeHtml(label)}</dt><dd>${escapeHtml(dash(value))}</dd></div>`).join('')}</dl>`;
}
